export const countries = {
  gp: {
    description:
      "L'île papillon offrant une riche culture créole et le volcan de la Soufrière.",
    landmarks: [
      "Volcan de la Soufrière",
      "Plage de Grande Anse",
      "Chutes du Carbet",
    ],
    gastronomy: "Accras de morue, colombo de poulet, tourment d'amour.",
  },
  mq: {
    description:
      "L'île aux fleurs envoûtante, réputée pour sa Montagne Pelée et son rhum.",
    landmarks: ["Montagne Pelée", "Jardin de Balata", "Rocher du Diamant"],
    gastronomy: "Poulet boucané, boudin créole, blanc-manger coco.",
  },
  gf: {
    description:
      "La porte de l'Europe vers l'espace avec une riche biodiversité amazonienne.",
    landmarks: ["Centre Spatial Guyanais", "Îles du Salut", "Marais de Kaw"],
    gastronomy: "Bouillon d'awara, fricassée de gibier, poulet rôti.",
  },
  re: {
    description:
      "Joyeux volcanique de l'océan Indien conjuguant lagons turquoise et cirques escarpés.",
    landmarks: [
      "Piton de la Fournaise",
      "Cirque de Mafate",
      "Piton des Neiges",
    ],
    gastronomy: "Rougail saucisse, cari poulet, samoussas.",
  },
  yt: {
    description:
      "L'île au parfum avec un lagon majestueux abritant des tortues marines.",
    landmarks: ["Lagon de Mayotte", "Mont Choungui", "Plage de N'Gouja"],
    gastronomy: "Brochettes de zébu, mataba, pilao.",
  },
  pf: {
    description:
      "Paradis du Pacifique, parsemé de bungalows et de récifs coralliens somptueux.",
    landmarks: ["Lagon de Bora Bora", "Mont Otemanu", "Baie de Cook"],
    gastronomy: "Poisson cru au lait de coco, fafaru, poe.",
  },
  nc: {
    description:
      "Terre de contrastes, avec le plus grand lagon fermé du monde et la culture Kanak.",
    landmarks: ["Le Phare Amédée", "Cœur de Voh", "Baie d'Oro"],
    gastronomy: "Bougna traditional, salade de cerf, ceviche.",
  },
  ic: {
    description:
      "Un archipel au printemps éternel sculpté par d'imposants paysages volcaniques.",
    landmarks: ["Parc du Teide", "Dunes de Maspalomas", "Timanfaya"],
    gastronomy: "Papas arrugadas, mojo rojo, sancocho.",
  },
  ptm: {
    description:
      "L'île plongeant dramatiquement dans l'Atlantique, avec ses splendides jardins.",
    landmarks: ["Pico do Arieiro", "Cabo Girão", "Les Levadas"],
    gastronomy: "Espetada, bolo do caco, poisson-sabre noir.",
  },
  pta: {
    description:
      "Un sanctuaire préservé où les cratères volcaniques forment des lacs jumeaux.",
    landmarks: ["Lagoa das Sete Cidades", "Mont Pico", "Sources de Furnas"],
    gastronomy: "Cozido das Furnas, fromage de São Jorge.",
  },
  aw: {
    description:
      "Des plages de sable blanc poudré sur une île caribéenne animée.",
    landmarks: ["Parc Arikok", "Eagle Beach", "Phare California"],
    gastronomy: "Keshi Yena, pastechi, ragoût de cabri.",
  },
  cw: {
    description:
      "Célèbre pour ses criques cristallines et l'architecture pastel néerlandaise.",
    landmarks: [
      "Pont de la Reine Emma",
      "Playa Porto Mari",
      "Parc Christoffel",
    ],
    gastronomy: "Karni stoba, arepa di pampuna.",
  },
  sx: {
    description:
      "The Friendly Island, réputée pour les avions rasant sa plage et sa gastronomie.",
    landmarks: ["Maho Beach", "Pic Paradis", "Orient Bay"],
    gastronomy: "Ribs au barbecue, journey cakes, crabe.",
  },
  bm: {
    description: "Archipel élégant bordé de mystérieuses plages de sable rose.",
    landmarks: [
      "Horseshoe Bay Beach",
      "Grottes de Cristal",
      "Phare de Gibbs Hill",
    ],
    gastronomy: "Soupe de poisson au rhum, hoppin' john.",
  },
  ky: {
    description:
      "Le paradis mondial de la plongée sous-marine avec ses fameuses raies.",
    landmarks: ["Stingray City", "Seven Mile Beach", "Parc Botanique"],
    gastronomy: "Bœuf local, accras de conque, gâteau manioc.",
  },

  fr: {
    description:
      "La France est la première destination touristique mondiale, réputée pour son patrimoine exceptionnel, ses paysages variés allant de la côte d'Azur aux sommets alpins, et un art de vivre incomparable.",
    gastronomy: "Baguette, fromages, vin, croissants, bœuf bourguignon.",
    landmarks: [
      "Tour Eiffel, Paris",
      "Mont Saint-Michel",
      "Châteaux de la Loire",
      "Côte d'Azur",
    ],
    overseas: [
      "Guadeloupe",
      "Martinique",
      "Guyane",
      "La Réunion",
      "Mayotte",
      "Polynésie française",
      "Nouvelle-Calédonie",
    ],
  },
  es: {
    description:
      "L'Espagne séduit par son climat ensoleillé, sa culture vibrante de la sieste au flamenco, ses plages magnifiques et son architecture historique unique, notamment l'héritage mauresque.",
    gastronomy: "Tapas, paella, jamón ibérico, gaspacho, sangria.",
    landmarks: [
      "Sagrada Família, Barcelone",
      "Alhambra, Grenade",
      "Palais Royal de Madrid",
      "Plaza de España, Séville",
    ],
    overseas: ["Îles Canaries", "Îles Baléares", "Ceuta", "Melilla"],
  },
  it: {
    description:
      "L'Italie est un véritable musée à ciel ouvert. Entre les ruines romaines, la Renaissance florentine, les canaux vénitiens et ses côtes pittoresques, le pays offre un voyage inoubliable.",
    gastronomy: "Pâtes, pizza, gelato, espresso, tiramisu.",
    landmarks: [
      "Colisée, Rome",
      "Tour de Pise",
      "Cathédrale de Florence",
      "Canal Grande, Venise",
    ],
    overseas: ["Sardaigne"],
  },
  de: {
    description:
      "L'Allemagne allie modernité urbaine et romantisme de ses châteaux et de la forêt Noire. Connue pour son dynamisme et son histoire riche.",
    gastronomy: "Bratwurst, bretzel, choucroute, bière.",
    landmarks: [
      "Porte de Brandebourg, Berlin",
      "Château de Neuschwanstein",
      "Cathédrale de Cologne",
      "Marienplatz, Munich",
    ],
  },
  gb: {
    description:
      "Le Royaume-Uni offre un mélange unique de tradition monarchique, d'avant-garde culturelle, de sublimes paysages écossais et de villes historiques.",
    gastronomy: "Fish and chips, roast beef, Yorkshire pudding, thé.",
    landmarks: [
      "Big Ben et le Palais de Westminster",
      "Stonehenge",
      "Tour de Londres",
      "Château d'Édimbourg",
    ],
    overseas: ["Bermudes", "Îles Caïmans", "Gibraltar"],
  },
  pt: {
    description:
      "Le Portugal ensorcelle avec ses ruelles colorées, ses plages baignées par l'Atlantique et l'accueil exceptionnel de ses habitants, sous la mélodie envoûtante du Fado.",
    gastronomy: "Pastéis de nata, bacalhau, Francesinha, vin de Porto.",
    landmarks: [
      "Tour de Belém, Lisbonne",
      "Ribeira, Porto",
      "Palais de Pena, Sintra",
      "Algarve",
    ],
    overseas: ["Madère", "Les Açores"],
  },
  gr: {
    description:
      "Berceau de la civilisation occidentale, la Grèce vous invite à un voyage mythologique, de l'Acropole aux eaux cristallines sublimes des îles des Cyclades.",
    gastronomy: "Moussaka, souvlaki, salade grecque, tzatziki.",
    landmarks: [
      "Acropole d'Athènes",
      "Santorin",
      "Météores",
      "Palais de Cnossos",
    ],
    overseas: ["Crète", "Rhodes"],
  },
  ch: {
    description:
      "La Suisse est un paradis alpin offrant des lacs d'un bleu profond, des forteresses médiévales et des montagnes stupéfiantes, idéal pour les amoureux de la nature et du confort.",
    gastronomy: "Fondue au fromage, raclette, chocolat suisse, rösti.",
    landmarks: [
      "Cervin (Matterhorn)",
      "Lac Léman",
      "Château de Chillon",
      "Jungfraujoch",
    ],
  },
  nl: {
    description:
      "Les Pays-Bas sont célèbres pour leurs paysages plats, leurs canaux labyrinthiques, leurs champs de tulipes et leurs moulins à vent emblématiques.",
    gastronomy: "Gouda, stroopwafel, hareng cru, poffertjes.",
    landmarks: [
      "Canaux d'Amsterdam",
      "Moulins de Kinderdijk",
      "Musée Van Gogh",
    ],
    overseas: ["Aruba", "Curaçao", "Saint-Martin"],
  },
  be: {
    description:
      "Au cœur de l'Europe, la Belgique est mondialement connue pour ses villes médiévales enchanteresses, la diplomatie européenne, son chocolat et sa bière.",
    gastronomy: "Gaufres, frites, moules, pralines, bières trappistes.",
    landmarks: [
      "Grand-Place de Bruxelles",
      "Belfroi de Bruges",
      "Atomium",
      "Château de Gravensteen",
    ],
  },
  bg: {
    description:
      "La Bulgarie est une mosaïque balkanique alliant côtes dorées de la mer Noire, montagnes montagneuses et un incroyable héritage thrace.",
    gastronomy: "Banitsa, salade Shopska, tarator, moussaka bulgare.",
    landmarks: [
      "Monastère de Rila",
      "Cathédrale Alexandre-Nevski",
      "Sunny Beach",
    ],
  },
  dk: {
    description:
      "Le Danemark représente le concept du 'Hygge' : un pays nordique paisible, pionnier du design, regorgeant de pistes cyclables et de palais royaux.",
    gastronomy: "Smørrebrød, frikadeller, Wienerbrød, bière Carlsberg.",
    landmarks: ["Nyhavn", "La Petite Sirène", "Château de Kronborg"],
    overseas: ["Îles Féroé", "Groenland"],
  },
  hr: {
    description:
      "La Croatie offre plus de mille îles le long de la mer Adriatique, parsemées de joyaux architecturaux romains et de parcs nationaux verdoyants.",
    gastronomy: "Ćevapi, salade de poulpe, peka, fromages de l'île de Pag.",
    landmarks: [
      "Remparts de Dubrovnik",
      "Parc national des lacs de Plitvice",
      "Palais de Dioclétien",
    ],
  },
  cy: {
    description:
      "Chypre est une île méditerranéenne légendaire, berceau d'Aphrodite, qui combine des plages immaculées avec des ruines antiques impressionnantes.",
    gastronomy: "Halloumi, souvla, sheftalia, moussaka.",
    landmarks: [
      "Parc archéologique de Paphos",
      "Rocher d'Aphrodite",
      "Massif du Troodos",
    ],
  },
  cz: {
    description:
      "La Tchéquie fascine par ses villes aux cent clochers, ses brasseries séculaires, et ses châteaux de conte de fées au cœur de l'Europe centrale.",
    gastronomy: "Goulash, Trdelník, Vepřo knedlo zelo, Pilsner.",
    landmarks: [
      "Pont Charles, Prague",
      "Château de Prague",
      "Ossuaire de Sedlec",
      "Karlovy Vary",
    ],
  },
  ee: {
    description:
      "L'Estonie est une nation pionnière du numérique abritant des forêts vierges immenses et une capitale médiévale intacte face à la Baltique.",
    gastronomy: "Verivorst (boudin noir), pain noir, sprat, bière artisanale.",
    landmarks: [
      "Vieille ville de Tallinn",
      "Parc national de Lahemaa",
      "Château d'Hermann",
    ],
  },
  fi: {
    description:
      "La Finlande, le pays aux mille lacs, est célèbre pour ses étendues sauvages étincelantes, l'aurore boréale en Laponie, et sa culture vitale du sauna.",
    gastronomy:
      "Saumon fumé, viande de renne, pain de seigle, brioches karjalanpiirakka.",
    landmarks: [
      "Suomenlinna",
      "Village du Père Noël",
      "Parc national de Nuuksio",
    ],
  },
  hu: {
    description:
      "La Hongrie est magnifiquement coupée par le Danube, foisonnant de spectaculaires bains thermaux, de vignobles historiques et du majestueux parlement.",
    gastronomy: "Goulash, Lángos, Paprikash de poulet, vin Tokaji.",
    landmarks: [
      "Parlement de Budapest",
      "Bains Széchenyi",
      "Château de Buda",
      "Lac Balaton",
    ],
  },
  ie: {
    description:
      "L'Irlande, l'île d'émeraude, est définie par ses falaises balayées par les vents, sa musique celtique chaleureuse et sa culture des pubs accueillante.",
    gastronomy: "Irish stew, Guinness, pain soda, colcannon.",
    landmarks: [
      "Falaises de Moher",
      "Guinness Storehouse",
      "Anneau de Kerry",
      "Trinity College",
    ],
  },
  lv: {
    description:
      "La Lettonie enchante avec sa capitale trépidante remplie d'architecture Art Nouveau et ses kilomètres de plages immaculées sur la côte baltique.",
    gastronomy: "Rupjmaize (pain de seigle noir), pois gris au bacon, sprats.",
    landmarks: [
      "Vieille ville de Riga",
      "Maison des Têtes noires",
      "Parc national de Gauja",
    ],
  },
  lt: {
    description:
      "La Lituanie est le joyau balte le plus au sud, riche en lacs glaciaires, forêts denses et témoignages touchants de son passé tumultueux.",
    gastronomy:
      "Cepelinai (boulettes de pomme de terre), soupe froide au bortsch (šaltibarščiai).",
    landmarks: [
      "Château de Trakai",
      "Colline des Croix",
      "Vieille ville de Vilnius",
    ],
  },
  lu: {
    description:
      "Le Luxembourg est un micro-État grand-ducal prospère, dont les vallées regorgent de châteaux médiévaux et la capitale est une citadelle spectaculaire.",
    gastronomy: "Judd mat Gaardebounen, Gromperekichelcher, vins de Moselle.",
    landmarks: [
      "Chemin de la Corniche",
      "Casemates du Bock",
      "Château de Vianden",
    ],
  },
  mt: {
    description:
      "Malte combine avec perfection la chaleur du soleil méditerranéen et 7 000 ans d'histoire navale, forteresses des Templiers et lagons turquoise.",
    gastronomy: "Pastizzi, ragoût de lapin (Stuffat tal-fenek), ftira.",
    landmarks: [
      "Co-cathédrale Saint-Jean",
      "Cité de Mdina",
      "Blue Lagoon (Comino)",
    ],
  },
  pl: {
    description:
      "La Pologne est le pilier culturel de l'Europe de l'Est, dotée d'imposantes cités restaurées, du tragique mémorial d'Auschwitz et des montagnes des Tatras.",
    gastronomy: "Pierogi, bigos, kielbasa, vodka polonaise.",
    landmarks: [
      "Place du marché de Cracovie",
      "Mines de sel de Wieliczka",
      "Auschwitz-Birkenau",
      "Château de Wawel",
    ],
  },
  ro: {
    description:
      "Dominée par la légende de Dracula, la Roumanie héberge les somptueux Carpates, le majestueux Delta du Danube et des villes transylvaniennes vibrantes.",
    gastronomy: "Mici, sarmale, mămăligă, tuică.",
    landmarks: [
      "Château de Bran",
      "Château de Peleș",
      "Delta du Danube",
      "Palais du Parlement",
    ],
  },
  sk: {
    description:
      "Moins connue, la Slovaquie est un trésor montagneux avec le plus grand nombre de châteaux par habitant au monde, au sein des Hautes Tatras.",
    gastronomy: "Bryndzové halušky (gnocchis au fromage de brebis), Kofola.",
    landmarks: ["Château de Bratislava", "Hautes Tatras", "Château de Spiš"],
  },
  si: {
    description:
      "La Slovénie est un petit paradis écologique abritant le mythique lac de Bled, de gigantesques grottes karstiques et une capitale verte exceptionnelle.",
    gastronomy: "Kranjska klobasa, potica (gâteau aux noix), štrukli.",
    landmarks: [
      "Lac de Bled",
      "Grottes de Postojna",
      "Château de Ljubljana",
      "Parc national du Triglav",
    ],
  },
  se: {
    description:
      "La Suède incarne le style scandinave, étalé sur des magnifiques archipels, des aurores boréales et une riche tradition de design épuré.",
    gastronomy:
      "Boulettes de viande (Köttbullar), fika, saumon gravlax, hareng surströmming.",
    landmarks: [
      "Musée Vasa",
      "Ville de Visby",
      "Gamla Stan (Stockholm)",
      "Hôtel de glace de Jukkasjärvi",
    ],
  },
  is: {
    description:
      "L'Islande, la terre de feu et de glace, foudroie d'admiration avec ses geysers, glaciers titanesques, volcans actifs et sources chaudes laiteuses.",
    gastronomy: "Hákarl (requin fermenté), Skyr, agneau islandais.",
    landmarks: [
      "Blue Lagoon",
      "Cercle d'Or",
      "Cascade de Gullfoss",
      "Plage de sable noir de Reynisfjara",
    ],
  },
  no: {
    description:
      "La Norvège offre un des plus beaux tableaux géologiques mondiaux : ses majestueux fjords abyssaux incisant la mer entourés de montagnes abruptes.",
    gastronomy: "Saumon, rakfisk, fromage brun (Brunost), viande d'élan.",
    landmarks: [
      "Geirangerfjord",
      "Cap Nord",
      "Îles Lofoten",
      "Bryggen (Bergen)",
    ],
  },
  al: {
    description:
      "Anciennement hermétique, l'Albanie est la pépite secrète de la Méditerranée regorgeant d'eaux d'un bleu cristallin, d'Alpes spectaculaires et de ruines greco-romaines.",
    gastronomy: "Byrek, fëgesë, fruits de mer, baklava.",
    landmarks: [
      "Riviera albanaise",
      "Berat (la ville aux mille fenêtres)",
      "Parc national de Butrint",
    ],
  },
  ad: {
    description:
      "Nichée haut dans les Pyrénées, cette minuscule principauté est un véritable sanctuaire pour les amoureux du ski et de la nature sauvage.",
    gastronomy: "Trinxat, escudella, charcuterie de montagne.",
    landmarks: ["Vallée du Madriu-Perafita-Claror", "Caldea", "Grandvalira"],
  },
  at: {
    description:
      "Pays alpin par excellence, l'Autriche brille par sa musique classique inégalable, ses palais impériaux et ses paysages alpins à couper le souffle.",
    gastronomy: "Wiener Schnitzel, Apfelstrudel, Sachertorte, Tafelspitz.",
    landmarks: ["Palais de Schönbrunn", "Hofburg", "Alpes de Kitzbühel"],
  },
  mc: {
    description:
      "Monaco est l'incarnation du glamour au bord de la Méditerranée, avec ses yachts de luxe, son célèbre casino, et le mythique Grand Prix de Formule 1.",
    gastronomy: "Barbajuan, fougasse monégasque, stocafi.",
    landmarks: [
      "Casino de Monte-Carlo",
      "Le Rocher de Monaco",
      "Palais Princier",
      "Port Hercule",
    ],
  },
  am: {
    description:
      "L'Arménie, l'une des plus anciennes nations chrétiennes au monde, offre des paysages montagneux spectaculaires et de majestueux monastères de pierre perchés aux abords de profonds canyons.",
    gastronomy: "Khorovats (barbecue arménien), dolma, lavash, lahmajoun.",
    landmarks: [
      "Monastère de Khor Virap",
      "Temple de Garni",
      "Monastère de Geghard",
    ],
  },
  az: {
    description:
      "L'Azerbaïdjan, la 'Terre de Feu', est un fascinant mélange de patrimoine historique millénaire et d'infrastructures ultra-modernes brillantes sur les rives de la mer Caspienne.",
    gastronomy: "Plov, dolma, piti, qutab, baklava.",
    landmarks: [
      "Flame Towers (Bakou)",
      "Vieille ville (Icherisheher)",
      "Volcans de boue de Gobustan",
    ],
  },
  by: {
    description:
      "La Biélorussie surprend par sa nature préservée, ses grandes forêts denses (comme Bialowieza) abritant des bisons, et ses châteaux médiévaux au riche passé.",
    gastronomy: "Draniki (galettes de pommes de terre), machanka, kolduny.",
    landmarks: ["Château de Mir", "Palais de Nesvizh", "Forteresse de Brest"],
  },
  ba: {
    description:
      "Un carrefour de cultures au cœur des Balkans où l'Orient rencontre l'Occident. Vous tomberez sous le charme des rivières émeraude, des montagnes escarpées et du célèbre Vieux Pont de Mostar.",
    gastronomy: "Ćevapi, burek, baklava, café bosniaque.",
    landmarks: [
      "Stari Most (Vieux Pont)",
      "Baščaršija (Sarajevo)",
      "Chutes de Kravica",
    ],
  },
  ge: {
    description:
      "La Géorgie offre une nature grandiose dans le massif du Caucase, une architecture ancienne fascinante et la réputation de posséder la plus ancienne région viticole du monde.",
    gastronomy: "Khachapuri, khinkali (raviolis), churchkhela.",
    landmarks: [
      "Église de la Trinité de Guerguéti",
      "Vieille ville de Tbilissi",
      "Vardzia (Cité troglodytique)",
    ],
  },
  xk: {
    description:
      "Une jeune nation balkanique, riche d'histoire et de paysages montagneux superbes, le Kosovo se distingue par des joyaux ottomans historiques bien préservés et une population très accueillante.",
    gastronomy: "Flija, burek, qebapa, fromage de Šar.",
    landmarks: [
      "Monastère de Visoki Dečani",
      "Vieux Prizren",
      "Montagnes de Rugova",
    ],
  },
  li: {
    description:
      "L'une des plus petites nations du monde, le Liechtenstein s'étire entre la Suisse et l'Autriche le long de la vallée du Rhin, dominé par son magnifique château princier et des pics alpins.",
    gastronomy: "Käsknöpfle (pâtes au fromage), Ribel.",
    landmarks: [
      "Château de Vaduz",
      "Musée d'Art (Kunstmuseum)",
      "Station de ski Malbun",
    ],
  },
  md: {
    description:
      "La Moldavie, trésor méconnu de l'Europe de l'Est, attire inévitablement les amateurs d'enotourisme avec ses immenses caves souterraines et ses monastères ancestraux taillés dans la roche.",
    gastronomy: "Mămăligă (polenta), plăcinte (galettes fourrées), sarmale.",
    landmarks: [
      "Orheiul Vechi (Monastère rupestre)",
      "Caves de Cricova",
      "Caves Mileștii Mici",
    ],
  },
  me: {
    description:
      "Malgré sa petite taille, le Monténégro cache certains des plus beaux paysages de la mer Adriatique. La baie de Kotor y côtoie de sombres montagnes spectaculaires (les 'montagnes noires').",
    gastronomy:
      "Brav u Mlijeku (agneau au lait), cevapi, jambon fumé de Njeguši.",
    landmarks: ["Baie de Kotor", "Parc national du Durmitor", "Sveti Stefan"],
  },
  mk: {
    description:
      "Au cœur des Balkans, la Macédoine du Nord émerveille par le lac millénaire d'Ohrid d'une clarté incomparable, son héritage orthodoxe et ses parcs nationaux préservés.",
    gastronomy: "Tavče gravče (fèves au four), ajvar, pastrmajlija.",
    landmarks: ["Lac d'Ohrid", "Église Saint-Jean de Kaneo", "Canyon Matka"],
  },
  sm: {
    description:
      "Perchée sur le mont Titano et complètement enclavée dans l'Italie, Saint-Marin prétend au titre de plus ancienne république et État souverain constitutionnel au monde.",
    gastronomy:
      "Torta Tre Monti (Gâteau des trois monts), piadina, faggioli con le cotiche.",
    landmarks: [
      "Les Trois Tours (Guaita, Cesta, Montale)",
      "Basilique de San Marino",
      "Piazza della Libertà",
    ],
  },
  rs: {
    description:
      "La Serbie allie la vie nocturne trépidante de Belgrade au bord du Danube, l'impressionnante forteresse de Petrovaradin et de superbes monastères orthodoxes cachés.",
    gastronomy: "Cevapi, pljeskavica, kajmak, rakija.",
    landmarks: [
      "Forteresse de Belgrade (Kalemegdan)",
      "Forteresse de Golubac",
      "Temple de Saint-Sava",
    ],
  },
  va: {
    description:
      "Vatican, le plus petit État souverain du monde, réside au cœur de Rome et constitue le siège spirituel de l'Église catholique, abritant de prodigieux joyaux artistiques de Michel-Ange.",
    gastronomy:
      "Pas de cuisine exclusive; on y déguste la traditionnelle gastronomie romaine.",
    landmarks: [
      "Basilique Saint-Pierre",
      "Chapelle Sixtine",
      "Musées du Vatican",
    ],
  },
};
